// extracted by mini-css-extract-plugin
export default {"renderer":"StyleMediaGridLayout_renderer__JkprM","emptyIcon":"StyleMediaGridLayout_emptyIcon__GBZNq"};